/* istanbul ignore file */
export const getAdAssetsFormStyles = (_, { palette = {} }) => ({
  adAssetsForm: {
    '& .unmapped-server-errors': {
      marginTop: '16px',
      marginBottom: '16px',
    },

    '& .final-url': {
      marginBottom: '8px',

      // In firefox isn't respecting the size of the svg, as it's being rendered as an image
      '& .title-item img': {
        width: '20px',
      },
    },

    '& .collapse-container': {
      gap: '16px',
    },
    '& .collapse-panel': {
      padding: '0 !important',
      borderRadius: '4px !important',
      marginBottom: '0px !important',

      '& .helpbutton': {
        '&::before': {
          verticalAlign: 'initial',
        },
      },

      '& .collapse-title-bar': {
        flexFlow: 'row wrap !important',
        padding: '16px 24px',
        minHeight: 'unset !important',
      },

      '&.collapse-fixed-panel': {
        '& .collapse-title-bar': {
          paddingBottom: '0',
        },
        '& .error-string-wrapper': {
          display: 'none',
        },
        '& .title-item': {
          width: 'auto',
          maxWidth: '100%',
        },
      },

      '&:not(.collapse-fixed-panel)': {
        '& .collapse-title-bar': {
          borderBottom: `1px solid ${palette.neutralLight}`,

          '& .title-item': {
            width: 'calc(100% - 18px)',
          },

          '& .error-string-wrapper': {
            position: 'unset',
            marginTop: '8px',
          },

          '& .toggle-icon': {
            fontSize: '18px',
          },
        },
      },

      '& .collapse-content': {
        padding: '12px 24px',
        marginBottom: '0 !important',

        '&.content-hide': {
          padding: '0',
        },
      },

      '& .collapse-content-details': {
        padding: '12px 24px',
      },
    },
  },
});
